module.exports = __webpack_public_path__ + "img/logo.66101acf.png";